import Component from './EditDeal.container';

export default Component;
